var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33341 15H5.00008V18.4008L9.25091 15H13.3334C14.2526 15 15.0001 14.2525 15.0001 13.3333V6.66667C15.0001 5.7475 14.2526 5 13.3334 5H3.33341C2.41425 5 1.66675 5.7475 1.66675 6.66667V13.3333C1.66675 14.2525 2.41425 15 3.33341 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6667 1.66666H6.66667C5.7475 1.66666 5 2.41416 5 3.33332H15C15.9192 3.33332 16.6667 4.08082 16.6667 4.99999V11.6667C17.5858 11.6667 18.3333 10.9192 18.3333 9.99999V3.33332C18.3333 2.41416 17.5858 1.66666 16.6667 1.66666Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.819438a26413c134a7e348bfbe3ccd6c.svg";
export { ForwardRef as ReactComponent };